import { BaseLayout } from "components";
import { LandingScreen } from "screens";

export function App() {
  return (
    <div className="App">
      <BaseLayout>
        <div className="flex flex-col items-center justify-between">
          <LandingScreen />

          <p className="mt-8 text-xs text-center">
            Accessibilité :{" "}
            <a
              href="https://www.accessibilite.ca-pacifica.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800 hover:text-blue-800 underline"
            >
              non conforme
            </a>
          </p>
        </div>
      </BaseLayout>
    </div>
  );
}
